import { useContext, useEffect, useState } from "react";
import campaignService from "../service/campaignService";
import { loaderContext, notificationContext } from "../context/context";
import { authService } from "../service";

function Overview() {
  const toast = useContext(notificationContext);
  const { showLoader, hideLoader } = useContext(loaderContext);
  const [selectedChip, setSelectedChip] = useState("week");

  const [statData, setStatData] = useState();

  const getDashboardStat = async () => {
    showLoader();
    const response = await campaignService.getOverview();

    hideLoader();
    if (response.error) {
      toast.error(response.error.message);
      return;
    }

    setStatData(response.data);
  };

  useEffect(() => {
    getDashboardStat();
  }, []);

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>Overview</h5>
        {/* <div className="container flex-center justify-content-end">
          <div className="">
            <div className="chip-grp bg-light ">
              <span
                className={(selectedChip === "week" && "chip active") || "chip"}
                onClick={() => setSelectedChip("week")}
              >
                Week
              </span>
              <span
                className={
                  (selectedChip === "month" && "chip active") || "chip"
                }
                onClick={() => setSelectedChip("month")}
              >
                Month
              </span>
              <span
                className={(selectedChip === "year" && "chip active") || "chip"}
                onClick={() => setSelectedChip("year")}
              >
                Year
              </span>
            </div>
          </div>
        </div> */}
      </div>
      <div className="mt-4">
        <div className="flex-nowrap gap-lg">
          <div className="card border rounded-border-sm p-2">
            <p className="title">Total Invoice</p>
            <h5>{statData?.invoice || 0}</h5>
          </div>
          <div className="card border rounded-border-sm p-2">
            <p className="title">Total SMS</p>
            <h5>{statData?.sms || 0}</h5>
          </div>
          <div className="card border rounded-border-sm p-2">
            <p className="title">Total Email</p>
            <h5>{statData?.email || 0}</h5>
          </div>
          <div className="card border rounded-border-sm p-2">
            <p className="title">Total Link</p>
            <h5>{statData?.link || 0}</h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Overview;
